(function () {
  if (window.maEta) return;
  window.maEta = true;
  function paint() {
    const note = document.documentElement.dataset.maShippingNote;
    document.querySelectorAll('[data-ma-eta-t]').forEach(element => {
      if (note && element.textContent !== note) element.textContent = note;
      else if (!note) element.hidden = true;
    });
    document.querySelectorAll('[data-ma-eta-uk]').forEach(element => { element.hidden = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  new MutationObserver(paint).observe(document.documentElement, {childList: true, subtree: true});
})();
